module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"ctaSubtitle":"Krijg gratis en geheel vrijblijvend tot zes waardebepalingen van makelaars uit jouw regio."},"en-GB":{"ctaSubtitle":"Get up to 6 free valuations from real state experts in your region"}}')
  delete Component.options._Ctor
}
